import { Component, computed, inject } from '@angular/core';
import { CustomerService } from '@modules/customer/customer.service';
import { UserService } from '@services/user.service';
import { Tag } from 'primeng/tag';
import { UserRolePipe } from '@modules/user/pipes/user.role.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-customer-profile-info',
    imports: [Tag, UserRolePipe, TranslatePipe],
    template: `
        <div class="menu-section">
            <div class="section-content">
                <div class="flex flex-column  justify-content-start gap-3">
                    <span class="epx-color-grey-600 font-semibold">{{ 'MODULE_USER.GENERAL.CURRENT_ACCOUNT' | translate }}</span>
                    <div class="flex flex-row align-items-center justify-content-between gap-1">
                        <span class="font-semibold">
                            {{ customerName() }}
                        </span>
                        <p-tag severity="contrast">{{ user().role | userRole }}</p-tag>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class CustomerProfileInfoComponent {
    customerService = inject(CustomerService);
    userService = inject(UserService);
    customer = this.customerService.customer;
    user = this.userService.user;
    customerName = computed(() => {
        const c = this.customer();
        return c.name;
    });
}
